import React, {Component, useEffect, useState} from 'react'
import autobind from 'autobind-decorator'
import TInputForm from "../../common/TInputForm";

export default function TextDetailForm({ typeId, defaultValue, placeholder, onChange, onFocus, onBlur }) {
  const [value, setValue] = useState(defaultValue)

  function handleChange(formValue) {
    onChange(typeId, formValue)
    setValue(formValue)
  }

  useEffect(() => {
    handleChange(defaultValue)
  }, [])

  return (
    <label className="lab_menu">
      <strong className="screen_out">텍스트 입력</strong>
      <TInputForm
        type="text" className="tf_blog" placeholder={placeholder} tabIndex="3" focus={true}
        value={value}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </label>
  )
}
